import { SET_RECOMMENDED_FIT } from 'constants/reduxActions';

export function setRecommendedFit(recommendedFit) {
  return {
    type: SET_RECOMMENDED_FIT,
    recommendedFit
  };
}
